import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import { MCard } from "components/Shared";
import {
  DATA_TYPE_DROPDOWN2,
} from "typeConstants/dataTypes";
import { CUSTOMER_INSIGHT_NOTIFICATION_EDIT, CUSTOMER_INSIGHT_NOTIFICATION_VIEW } from "typeConstants/rights";
import { userHasRight } from "selectors/rights";
import { MCardField } from "components/Shared/MCard.tsx";

interface AddCustomerInsightNotificationAccountProps {
  onCancel: () => void;
  onSubmit: (request: number) => void;
  canViewCustomerDetails: boolean;
  canEditCustomerDetails: boolean;  
  availableAccounts: { label: string; value: number }[];
  cardLabel?: string;
  customerInsightNotificationId: number;
}

const AddCustomerInsightNotificationAccount = (props: AddCustomerInsightNotificationAccountProps) => {
  const [newCustomerInsightNotificationAccountId, setNewCustomerInsightNotificationAccountId] = useState<number>(null);
  const cardControlMethods = useRef({});
  const mounted = useRef(true);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  const onAffirm = () => {
    if (newCustomerInsightNotificationAccountId) {
      props.onSubmit(newCustomerInsightNotificationAccountId);
    }
  };

  const onNegate = () => {
    props.onCancel();
  };

  const getAffirmButtonLabel = "Submit";
  const getNegateButtonLabel = "Cancel";
  let cardFields: MCardField[] = [
    {
      key: props.cardLabel,
      label: props.cardLabel,
      editable: props.canEditCustomerDetails,
      value: props.availableAccounts.find(r => r.value === newCustomerInsightNotificationAccountId),
      dataType: DATA_TYPE_DROPDOWN2,
      dataTypeOptions: { options: props.availableAccounts, nullable: false },
      onChange: (selection) => setNewCustomerInsightNotificationAccountId(selection.value),
    },
  ];

  return (
    <div className="add-customer-insight-notification-account">
      <MCard
        key={"account-list-card"}
        title={`Select ${props.cardLabel} to Add`}
        onlyEditable
        fields={cardFields}
        getControlMethods={controlMethods => cardControlMethods.current = controlMethods}
      />
      <div className="button-container">
        <Button
          onClick={onNegate}
        >{getNegateButtonLabel}</Button>
        <Button
          onClick={onAffirm}
        >{getAffirmButtonLabel}</Button>
      </div>  
    </div>
  );
};

const mapStateToProps = state => ({
  canViewCustomerDetails: userHasRight(CUSTOMER_INSIGHT_NOTIFICATION_VIEW)(state),
  canEditCustomerDetails: userHasRight(CUSTOMER_INSIGHT_NOTIFICATION_EDIT)(state),
});

export default connect(mapStateToProps, null)(AddCustomerInsightNotificationAccount);